import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { BUSINESS_TYPE, DOC_STATE, SLA_DATA } from 'src/app/constants/endpoint.const';
import { BusinessListType, SlaBusinessInformation, SlaData } from 'src/app/models/documents.model';
import { BaseService } from 'src/app/services/base.service';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { setRegex } from 'src/app/libs/functions/common.functions';
@Component({
  standalone: false,
  selector: 'app-sla-data-input-qrisly',
  templateUrl: './sla-data-input-qrisly.component.html',
  styleUrl: './sla-data-input-qrisly.component.scss'
})
export class SlaDataInputQrislyComponent implements OnInit, OnChanges, OnDestroy {
  loading: boolean = true;
  setRegex = setRegex;

  destroy$ = new Subject<void>();
  businessTypeList: BusinessListType[] = [];
  @Input() slaDataInput?: SlaBusinessInformation;
  @Output() businessData = new EventEmitter<SlaBusinessInformation>();
  businessForm!: FormGroup;
  errMessEmail: string = '';
  validEmail: boolean = true;
  errMessBName: string = '';
  validBName: boolean = true;
  validNumber: boolean = true;
  errMessNumber: string = '';
  validAddress: boolean = true;
  errMessAddress: string = '';
  isConfirmBack: boolean = false;
  @Output() openModalConfirmBack = new EventEmitter<boolean>();
  serviceType: string = localStorage.getItem('service_type_doc') || '';
  mode: string = localStorage.getItem('mode-sla-input-qrisly') || '';
  slaData: SlaData = {};

  validEntityOthers: boolean = true;
  errMessEntityOthers: string = '';
  constructor(
    private BaseService: BaseService,
    private fb: FormBuilder,
    private router: Router,
    private formValidation: FormValidationService,
    private message: NzMessageService
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    setTimeout(() => { this.loading = false; }, 1000);
    this.initForm();
    this.setupFormSubscriptions();
    this.getSLAData();
    this.getBusinessType();
    if (this.slaDataInput) {
      this.businessForm.patchValue(this.slaDataInput);
      this.checkEntityOthersState();
    }

  }

  setupFormSubscriptions(): void {
    this.businessForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      const stored = localStorage.getItem('slaDataQrisly');
      const current = stored ? JSON.parse(stored) : {};
      localStorage.setItem('slaDataQrisly', JSON.stringify({ ...current, ...value }));
    });

    this.businessForm.get('business_entity')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      const othersControl = this.businessForm.get('business_entity_others_name');
      if (value === 5) {
        othersControl?.setValidators([Validators.required, Validators.maxLength(20)]);
      } else {
        othersControl?.clearValidators();
        othersControl?.setValue('', { emitEvent: false });
        this.validEntityOthers = true;
        this.errMessEntityOthers = '';
      }
      othersControl?.updateValueAndValidity({ emitEvent: false });
      this.validateEntityOthers();
    });

    this.businessForm.get('business_entity_others_name')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.validateEntityOthers();
    });
  }

  checkEntityOthersState(): void {
    const entityValue = this.businessForm.get('business_entity')?.value;
    const othersControl = this.businessForm.get('business_entity_others_name');

    if (entityValue === 5) {
      othersControl?.setValidators([Validators.required, Validators.maxLength(20)]);
      othersControl?.updateValueAndValidity({ emitEvent: false });
      this.validateEntityOthers();
    } else {
      othersControl?.clearValidators();
      othersControl?.updateValueAndValidity({ emitEvent: false });
      this.validEntityOthers = true;
      this.errMessEntityOthers = '';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['slaDataInput']?.currentValue && this.businessForm) {
      this.businessForm.patchValue(changes['slaDataInput'].currentValue);
      this.checkEntityOthersState();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initForm(): void {
    this.businessForm = this.fb.group({
      business_entity: [null, Validators.required],
      business_entity_others_name: [''],
      business_name: ['', Validators.required],
      business_email: ['', [Validators.required, Validators.email]],
      business_type: [null, Validators.required],
      business_address: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(100)]],
      business_phone: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      is_account_data_consent: [true, Validators.required],
    });
  }

  back(): void {
    this.isConfirmBack = true;
  }

  closeConfirmBack(): void {
    this.isConfirmBack = false;
  }

  getSLAData(): void {
    this.BaseService.getData(`${SLA_DATA}/qrisly`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.data !== null) {
            this.slaData = res.data;
            delete this.slaData.city_id;
            delete this.slaData.city_name;
          } else {
            this.slaData = {};
          }

          let formValue = { ...this.slaData };
          const storedData = localStorage.getItem('slaDataQrisly');
          if (storedData) {
            const parsedStored = JSON.parse(storedData);
            delete parsedStored.city_id;
            delete parsedStored.city_name;

            Object.keys(parsedStored).forEach(key => {
              if (parsedStored[key] === '' || parsedStored[key] === null) {
                delete parsedStored[key];
              }
            });

            formValue = { ...formValue, ...parsedStored };
          }

          this.businessForm.patchValue(formValue);
          this.checkEntityOthersState();
          localStorage.setItem('slaDataQrisly', JSON.stringify(formValue));
        },
        error: () => {
          this.message.error('Failed to fetch SLA data.');
        }
      });
  }

  getBusinessType(): void {
    this.BaseService.getData(BUSINESS_TYPE)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.businessTypeList = res.data;
        },
        error: (err) => {
          this.message.error(err.error.meta.message || 'Failed to get business type');
        }
      });
  }

  private navigateToStep(step: number): void {
    const queryParams: Record<string, string | number> = {
      step,
      service_type: this.serviceType,
    };
    if (this.mode !== 'create') {
      queryParams['mode'] = this.mode;
    }
    this.router.navigate(['/document/sla-data-input-qrisly'], { queryParams });
  }

  onSubmit(): void {
    if (!this.businessForm.valid) {
      this.message.error('Form is invalid!');
      return;
    }

    const data = {
      ...this.businessForm.value
    }
    const request = Object.keys(this.slaData).length === 0
      ? this.BaseService.postData(SLA_DATA + '/qrisly', data) :
      this.BaseService.putData(SLA_DATA + '/qrisly', data)
    request.pipe(takeUntil(this.destroy$))
        .subscribe(
          () => {
            this.message.create('success', 'SLA Data has been submitted successfully');
            localStorage.removeItem('slaDataQrisly');
            this.updateState();
          },
          (err) => {
            this.message.create('error', err.error?.meta?.message || 'Submission SLA Data Document failed, please check the completeness of the data.');
          }
        );
  }

  updateState(): void {
    const params = {
      document_type: 'SLA',
      state: 3,
      service_types_id: 3,
    };
    this.BaseService.putData(DOC_STATE, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.router.navigate(['/document']);
        },
        (err) => {
          this.message.error(err.error.meta.message || 'Failed to update state');
          this.router.navigate(['/document']);
        }
      );
  }

  setRegexBName(event: KeyboardEvent): boolean {
    return /^[a-zA-Z .-]+$/.test(event.key);
  }

  validateEntityOthers() {
    if (this.businessForm.get('business_entity')?.value !== 5) return;

    const value = this.businessForm.get('business_entity_others_name')?.value || '';
    if (value === '') {
      this.validEntityOthers = false;
      this.errMessEntityOthers = 'Please fill in this field';
    } else if (value.length > 20) {
      this.validEntityOthers = false;
      this.errMessEntityOthers = 'Maximum 20 characters';
    } else {
      this.validEntityOthers = true;
      this.errMessEntityOthers = '';
    }
  }

  validateBusinessName(): void {
    const value = this.businessForm.get('business_name')?.value || '';

    if (value === '') {
      this.validBName = false;
      this.errMessBName = 'Business Name must be filled in';
    } else if (value.length < 3) {
      this.validBName = false;
      this.errMessBName = 'Minimum 3 characters';
    } else if (value.length > 50) {
      this.validBName = false;
      this.errMessBName = 'Maximum 50 characters';
    } else {
      this.validBName = true;
      this.errMessBName = '';
    }
  }

  validateEmail(): void {
    const value = this.businessForm.get('business_email')?.value || '';
    const result = this.formValidation.validateEmail(value);
    this.validEmail = result.valid;
    this.errMessEmail = result.message;
  }

  preventNonNumeric(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];

    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
    if (input.value.length === 0 && event.key !== '8') {
      event.preventDefault();
    }
  }

  validateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const result = this.formValidation.validatePhoneNumber(input.value);
    this.validNumber = result.valid;
    this.errMessNumber = result.message;
  }

  validateAddress(): void {
    const value = this.businessForm.get('business_address')?.value || '';

    if (value.length === 0) {
      this.validAddress = false;
      this.errMessAddress = 'Address cannot be empty';
    } else if (value.length < 10) {
      this.validAddress = false;
      this.errMessAddress = 'Minimum 10 characters';
    } else if (value.length > 100) {
      this.validAddress = false;
      this.errMessAddress = 'Maximum 100 characters';
    } else {
      this.validAddress = true;
      this.errMessAddress = '';
    }
  }

  get isFormInvalid(): boolean {
    return (
      this.businessForm.invalid ||
      this.errMessEmail !== '' ||
      this.errMessBName !== '' ||
      this.errMessAddress !== '' ||
      this.errMessNumber !== '' ||
      this.errMessEntityOthers !== ''
    );
  }
}
